import { Button } from '@material-ui/core'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import CancelConfirmButtons from 'Components/UI/Molecules/CancelConfirmButtons'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'

const Upload = (props) => {
  const { open, handleClose, onSubmit, handleChange, change, loading } = props
  return (
    <DialogComponent
      open={open}
      handleclose={loading ? null : handleClose}
      title="Subir foto/s"
      children={
        <form>
          <input
            style={{ display: 'none' }}
            accept="image/*"
            id="contained-button-file"
            name="file"
            type="file"
            multiple
            onChange={handleChange}
          />
          <label htmlFor="contained-button-file">
            {change.length > 0 ? (
              <Button
                color="primary"
                startIcon={<CheckCircleOutlineIcon />}
                variant="contained"
                fullWidth
                component="span"
                disabled={loading}
              >
                Imagenes seleccionadas
              </Button>
            ) : (
              <Button variant="contained" fullWidth component="span">
                Seleccionar imagen/es
              </Button>
            )}
          </label>
        </form>
      }
      actions={
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <CancelConfirmButtons
            onClickCancel={() => {
              handleClose()
            }}
            onClickSubmit={() => {
              onSubmit(change)
            }}
            isLoading={loading}
            disabledCancel={loading}
            disabledSubmit={loading || change.length < 1}
          />
        </div>
      }
    />
  )
}

export default Upload
